var _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdviserNumber3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 57C22 76.33 37.67 92 57 92C76.33 92 92 76.33 92 57C92 37.67 76.33 22 57 22",
    stroke: "#081E56",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57 102C77.8781 102 95.4353 87.7818 100.517 68.5M12 57C12 32.1472 32.1472 12 57 12C74.6686 12 89.9589 22.1828 97.3224 37",
    stroke: "#FDE966",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57 2C87.3757 2 112 26.6243 112 57C112 59.7172 111.803 62.3884 111.422 65M14.1636 22.5C6.55503 31.9351 2 43.9356 2 57C2 85.3482 23.4468 108.687 51 111.676",
    stroke: "#F4F4F9",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6553 46.0732C70.6553 47.8486 70.2861 49.3867 69.5479 50.6875C68.8096 51.9883 67.8076 53.0518 66.542 53.8779C65.2939 54.7041 63.8877 55.3105 62.3232 55.6973V55.8555C65.417 56.2422 67.7637 57.1914 69.3633 58.7031C70.9805 60.2148 71.7891 62.2363 71.7891 64.7676C71.7891 67.0176 71.2354 69.0303 70.1279 70.8057C69.0381 72.5811 67.3506 73.9785 65.0654 74.998C62.7803 76.0176 59.8359 76.5273 56.2324 76.5273C54.1055 76.5273 52.1191 76.3516 50.2734 76C48.4453 75.666 46.7227 75.1475 45.1055 74.4443V67.5098C46.7578 68.3535 48.4893 68.9951 50.2998 69.4346C52.1104 69.8564 53.7979 70.0674 55.3623 70.0674C58.2803 70.0674 60.3193 69.5664 61.4795 68.5645C62.6572 67.5449 63.2461 66.1211 63.2461 64.293C63.2461 63.2207 62.9736 62.3154 62.4287 61.5771C61.8838 60.8389 60.9346 60.2764 59.5811 59.8896C58.2451 59.5029 56.373 59.3096 53.9648 59.3096H51.0381V53.0605H54.0176C56.3906 53.0605 58.1924 52.8408 59.4229 52.4014C60.6709 51.9443 61.5146 51.3291 61.9541 50.5557C62.4111 49.7646 62.6396 48.8682 62.6396 47.8662C62.6396 46.4951 62.2178 45.4229 61.374 44.6494C60.5303 43.876 59.124 43.4893 57.1553 43.4893C55.9248 43.4893 54.7998 43.6475 53.7803 43.9639C52.7783 44.2627 51.873 44.6318 51.0645 45.0713C50.2559 45.4932 49.5439 45.9062 48.9287 46.3105L45.1582 40.6943C46.6699 39.6045 48.4365 38.6992 50.458 37.9785C52.4971 37.2578 54.9229 36.8975 57.7354 36.8975C61.708 36.8975 64.8545 37.6973 67.1748 39.2969C69.4951 40.8965 70.6553 43.1553 70.6553 46.0732Z",
    fill: "#081E56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.6641,
    cy: 56.7041,
    r: 35,
    stroke: "#081E56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdviserNumber3);
export default __webpack_public_path__ + "static/media/Adviser-Number3.ffcd2892a547735061521135b767f00f.svg";
export { ForwardRef as ReactComponent };